

type CardProps = {
    cardClass: string
    imageWrapperClass: string
    imageAlt: string
    imageSrc: string
    textWrapperClass?: string
    cover?: string
    children?: React.ReactNode
}

export const Card = ({ cardClass, imageWrapperClass, imageAlt, imageSrc, textWrapperClass, children, cover, ...rest }: CardProps) => {
    return (
        <div className={cardClass} {...rest}>
            <img className={imageWrapperClass} alt={imageAlt} src={imageSrc} />
            <div className={textWrapperClass}>
                {children}
            </div>
        </div>
    )
}